import type { InputSource } from '../types';

export const solid: InputSource = {
  label: 'Solid',
  value: 'solid',
  draw: (ctx, width, height, options) => {
    ctx.fillStyle = options?.solidColor || '#ffffff';
    ctx.fillRect(0, 0, width, height);
  },
  settings: [
    {
      label: 'Solid Colour',
      key: 'solidColor',
      type: 'color',
      default: '#ffffff',
    },
  ],
};
